// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__UYU5X","containerItemsCenter":"Skeleton_containerItemsCenter__3YUf1"};